import { render } from "./ModalComp.vue?vue&type=template&id=401822d4"
import script from "./ModalComp.vue?vue&type=script&lang=js"
export * from "./ModalComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__